import { enBackoffice } from './en/backoffice';
import { enCore } from './en/core';
import { enDapur } from './en/dapur';
import { enKasir } from './en/kasir';
import { enMenu } from './en/menu';
import { enOrder } from './en/order';
import { enPelayan } from './en/pelayan';
import { enStok } from './en/stok';
import { enStokInsights } from './en/stok-insights';
import { enRecipes } from './en/recipes';
import { enStokTransfers } from './en/stok-transfers';
import { enBoApPayments } from './en/bo-ap-payments';
import { enBoApInvoices } from './en/bo-ap-invoices';
import { enBoBudgets } from './en/bo-budgets';
import { enBoApprovals } from './en/bo-approvals';
import { enStokRequests } from './en/stok-requests';
import { enApprovals } from './en/approvals';
import { enStokCounts } from './en/stok-counts';
import { enStokLots } from './en/stok-lots';
import { enStokProcurement } from './en/stok-procurement';
import { enStokWaste } from './en/stok-waste';
import { enAccount } from './en/account';
import { enBillingSaas } from './en/billing-saas';
import { enBranding } from './en/branding';
import { enPlatform } from './en/platform';
import { enDataLifecycle } from './en/data-lifecycle';
import { enGudang } from './en/gudang';

/**
 * English catalog — the reference catalog, composed from one file per area so each
 * interface owns its copy. Keys are flat, dot-namespaced and stable. Placeholders use
 * `{name}` and must appear identically in every locale (enforced by `catalog.test.ts`).
 * Never concatenate translated fragments; add a key with params.
 */
export const en = {
  ...enCore,
  ...enOrder,
  ...enKasir,
  ...enDapur,
  ...enPelayan,
  ...enBackoffice,
  ...enMenu,
  ...enStok,
  ...enStokProcurement,
  ...enStokLots,
  ...enStokWaste,
  ...enBranding,
  ...enStokCounts,
  ...enApprovals,
  ...enStokRequests,
  ...enBoApprovals,
  ...enBoBudgets,
  ...enStokInsights,
  ...enRecipes,
  ...enStokTransfers,
  ...enBoApPayments,
  ...enBoApInvoices,
  ...enAccount,
  ...enBillingSaas,
  ...enPlatform,
  ...enDataLifecycle,
  ...enGudang,
} as const;

export type MessageKey = keyof typeof en;
export type Catalog = Record<MessageKey, string>;
